import { render, staticRenderFns } from "./TherapyTemplateDisclaimer.vue?vue&type=template&id=7cd9e087&scoped=true&"
import script from "./TherapyTemplateDisclaimer.vue?vue&type=script&lang=js&"
export * from "./TherapyTemplateDisclaimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd9e087",
  null
  
)

export default component.exports